import { EAFSGAreaApi, EAFSGAreaDTO, EAFSGAreaUpdateDTO } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new EAFSGAreaApi(getAuthConfiguration());

export const getEAFSGAreas = (namePattern?: string, page: number = 1, pageSize: number = 10) => {
    return ApiFactory().apiEAFSGAreaGetAllEAFSGAreasGet({ page, pageSize, namePattern });
}

export const getEAFSGArea = (id: string) => {
    if (!id) {
        return {} as EAFSGAreaDTO;
    }
    return ApiFactory().apiEAFSGAreaGetEAFSGAreaByIdIdGet({ id });
}

export const addEAFSGArea = (eAFSGAreaUpdateDTO: EAFSGAreaUpdateDTO) => {
    return ApiFactory().apiEAFSGAreaAddEAFSGAreaPost({ eAFSGAreaUpdateDTO });
}

export const updateEAFSGArea = (id: string, eAFSGAreaUpdateDTO: EAFSGAreaUpdateDTO) => {
    return ApiFactory().apiEAFSGAreaUpdateEAFSGAreaIdPut({ id, eAFSGAreaUpdateDTO });
}

export const deleteEAFSGArea = (id: string) => {
    return ApiFactory().apiEAFSGAreaDeleteEAFSGAreaIdDelete({ id });
}
